import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { useOverlayScrollbars } from 'overlayscrollbars-react';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import './FloatingScrollArea.css';

/** ref는 실제 스크롤 요소다. 휠·터치·키보드와 scrollTop 복원은 브라우저가 처리한다. */
const FloatingScrollArea = forwardRef(function FloatingScrollArea({
  children, className = '', style, axis = 'both', onScroll, tabIndex = 0, ...viewportProps
}, forwardedRef) {
  const host = useRef(null);
  const viewport = useRef(null);
  const [initialize, instance] = useOverlayScrollbars({
    options: {
      // 모바일처럼 기본 막대가 이미 공간을 차지하지 않으면 그대로 사용한다.
      showNativeOverlaidScrollbars: true,
      overflow: { x: axis === 'y' ? 'hidden' : 'scroll', y: axis === 'x' ? 'hidden' : 'scroll' },
      scrollbars: {
        theme: 'os-theme-dark',
        visibility: 'auto',
        autoHide: 'scroll',
        autoHideDelay: 900,
        autoHideSuspend: false,
      },
    },
  });
  useImperativeHandle(forwardedRef, () => viewport.current, []);
  useEffect(() => {
    initialize({ target: host.current, elements: { viewport: viewport.current, content: viewport.current } });
    return () => instance()?.destroy();
  }, [initialize, instance]);

  return <div ref={host} data-floating-scroll="" data-overlayscrollbars-initialize="" className={`min-h-0 min-w-0 ${className}`} style={style}>
    <div ref={viewport} data-overlayscrollbars-contents="" tabIndex={tabIndex} onScroll={onScroll} {...viewportProps}>
      {children}
    </div>
  </div>;
});

export default FloatingScrollArea;
